import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const CASH: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Cash,
    name: 'cash'
};
